import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 暂时不要轮播了，
// 只有一个页面用到，css在用到的地方引入了
// "swiper": "^5.2.0",
// "vue-awesome-swiper": "^4.1.1",
Vue.use(VueAwesomeSwiper)